import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-global-layout',
  templateUrl: './global-layout.component.html',
  styleUrls: ['./global-layout.component.scss']
})
export class GlobalLayoutComponent implements OnInit {

  expandSidebar: boolean = true;
 
  constructor(private router: Router) {
  }

  ngOnInit(): void {
    
  }

  public isHome() {
    return this.router.url == "/";
  }
  public urlContains(part: any) {
    return this.router.url.includes(part);  
  }

}
